import { YandexMetrikaAbTestModule } from '@analytics/feature';
import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { PagesNavigationModule } from '@main/navigation/ui';
import { HeaderCitySelectModule } from '@sdvor/city/ui';
import { ComparisonModule } from '@sdvor/comparison/ui';
import { CategoriesMenuModule } from '@sdvor/main/categories-menu/ui';
import { PhoneComponentModule } from '@sdvor/main/phone/ui';
import { LogoComponent, SdvorGenericLinkComponent, TabComponent } from '@sdvor/shared/ui';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { IconModule } from '@spartacus/storefront';
import { MobileMenuComponent } from './mobile-menu.component';

@NgModule({
  declarations: [MobileMenuComponent],
  exports: [MobileMenuComponent],
  imports: [
    NgIf,
    AsyncPipe,
    LogoComponent,
    IconModule,
    YandexMetrikaAbTestModule,
    TabComponent,
    HeaderCitySelectModule,
    SdvorGenericLinkComponent,
    CategoriesMenuModule,
    ComparisonModule,
    PagesNavigationModule,
    PhoneComponentModule,
    SdvorIconComponent,
  ],
})
export class MobileMenuModule {}
